<template>
  <div id="app">
    <MobileHeader></MobileHeader>
    <div class="corzo-body-outer-wrapper">
      <div class="corzo-body-wrapper clearfix corzo-with-frame">
<!--        <div class="corzo-top-bar">-->
<!--          <div class="corzo-top-bar-background"></div>-->
<!--          <div class="corzo-top-bar-container corzo-container">-->
<!--            <div class="corzo-top-bar-container-inner clearfix">-->
<!--              <div class="corzo-top-bar-left corzo-item-pdlr">-->
<!--                <div class="corzo-top-bar-left-text">-->
<!--                  <ul id="corzo-top-bar-menu" class="sf-menu corzo-top-bar-menu corzo-top-bar-left-menu">-->
<!--&lt;!&ndash;                    <li class="menu-item corzo-normal-menu">&ndash;&gt;-->
<!--&lt;!&ndash;                      <a href="#">投资人</a></li>&ndash;&gt;-->
<!--&lt;!&ndash;                    <li class="menu-item corzo-normal-menu">&ndash;&gt;-->
<!--&lt;!&ndash;                      <a href="#/contact">联系我们</a></li>&ndash;&gt;-->
<!--                  </ul>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="corzo-top-bar-right corzo-item-pdlr">-->
<!--                <div class="corzo-top-bar-right-social">-->
<!--&lt;!&ndash;                  <a href="#" target="_blank" class="corzo-top-bar-social-icon" title="facebook">&ndash;&gt;-->
<!--&lt;!&ndash;                    <i class="fa fa-wechat"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                  </a>&ndash;&gt;-->
<!--&lt;!&ndash;                  <a href="#" target="_blank" class="corzo-top-bar-social-icon" title="linkedin">&ndash;&gt;-->
<!--&lt;!&ndash;                    <i class="fa fa-telegram"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                  </a>&ndash;&gt;-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <Header></Header>
        <!-- header -->
        <div class="corzo-page-wrapper" id="corzo-page-wrapper">
          <div class="gdlr-core-page-builder-body">
            <router-view/>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
  </div>
</template>

<script>
import MobileHeader from '@/components/MobileHeader'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
export default {
  name: 'App',
  components: {
    MobileHeader,
    Header,
    Footer
  },
  data () {
    return {
      currentMenu: 'home'
    }
  },
  methods: {
  }
}
</script>

<style>
#app {
}
</style>



// WEBPACK FOOTER //
// src/App.vue